import circleBg from '@/assets/notifications/position-value-change/medallion-circle-bg.svg';
import arrowUp from '@/assets/notifications/position-value-change/medallion-arrow-up.png';
import triangleUp from '@/assets/notifications/position-value-change/indicator-triangle-up.svg';
import { POPUP_CTA } from '@/lib/notifications/popup-cta';
import { marketTitle, metaNumber } from '@/lib/notifications/meta';
import { Medallion } from '../Medallion';
import { PopupCta } from '../PopupCta';
import type { PopupViewProps } from '../types';

const CTA = POPUP_CTA['position-value-change'];

/**
 * POSITION_VALUE_CHANGE — trending-UP variant only (the PRD ships positive moves
 * only). Positive/green tone: green circle + up-arrow medallion, the market
 * title, and a big green up-triangle + "{pct}%" delta. CTA "View position" →
 * navigateMarket.
 *
 * Meta comes from `positionValueChangeNotification` (predictions-api):
 * `changePercent` (signed number, e.g. 12.5) and `marketName`. We render the
 * magnitude (`round(abs(changePercent))`); the up presentation is fixed per the
 * PRD (a down variant is out of scope for this ticket).
 */
export function PositionValueChangePopup({ notification, onAction }: PopupViewProps) {
  const meta = notification.meta;
  const title = marketTitle(meta);
  const changePercent = metaNumber(meta, 'changePercent');
  const pct = changePercent !== undefined ? Math.round(Math.abs(changePercent)) : undefined;

  return (
    <>
      <Medallion circleSrc={circleBg} illustrationSrc={arrowUp} tone="positive" alt="" />

      <div className="flex flex-col items-center gap-2">
        <h2 className="text-3xl font-semibold tracking-[-0.6px] text-ink">Your call is trending up</h2>

        {title && <p className="text-xl font-bold text-ink">{`“${title}”`}</p>}

        {pct !== undefined && (
          <div className="flex items-center gap-2" data-testid="value-change-delta">
            <img src={triangleUp} alt="" aria-hidden className="h-6 w-5" />
            <span className="text-[46px] font-bold leading-none tracking-[-0.92px] text-success">{`${pct}%`}</span>
          </div>
        )}
      </div>

      <PopupCta
        label={CTA.primary.label}
        width={234}
        onClick={() => onAction(CTA.primary.action)}
        testId="popup-cta-primary"
      />
    </>
  );
}
